import {Component, OnInit} from '@angular/core';
import {AuthService} from './core/services';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {UserService} from "./core/services/user.service";
import {MessageService, PrimeNGConfig} from "primeng/api";
import {LoadingIndicatorService} from "./core/services/loading-indicator.service";
import {Helper} from "./shared/helper/helper";
import {GoogleTagManagerService} from "angular-google-tag-manager";
import {CookieService} from "ngx-cookie-service";
import Role from "./shared/enums/role.enum";
import {SubscriptionService} from "./core/services/subscription.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'Loop Plus';

    // Properties for AGB dialog
    agb = false;
    checked = false;
    link1 = 'https://www.lobster-event.com/datenschutz';
    link2 = 'https://www.lobster-event.com/agb';

    type = "buyer";

    constructor(
        private authService: AuthService,
        private userService: UserService,
        private primengConfig: PrimeNGConfig,
        public loader: LoadingIndicatorService,
        public message: MessageService,
        private route: ActivatedRoute,
        private router: Router,
        public helper: Helper,
        private gtmService: GoogleTagManagerService,
        private cookieService: CookieService,
        private subscriptionService: SubscriptionService
    ) {
        this.route.queryParams.subscribe(params => {
            if(params['internal']){
                this.cookieService.set('internal', 'true', 365);
            }
            this.router.events.forEach((item => {
                if(item instanceof NavigationEnd && !this.cookieService.get('internal')) {
                    const gtmTag = {
                        event: 'page',
                        pageName: item.url
                    };
                    this.gtmService.pushTag(gtmTag);
                }
            }));
        })
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        
        // Router-Events synchron registrieren
        this.setupRouterEvents();
        
        // Asynchrone Operationen parallel ausführen
        this.initializeAsync();
    }

    private setupRouterEvents(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.authService.userSubject.subscribe((user) => {
                    if (user && !event.urlAfterRedirects.includes('scheduling')) {
                        this.authService.getUser().then((u) => {
                            this.type = this.helper.hasRole(Role.BUYER) ? 'buyer' : 'supplier';
                            if (u.loop_agb_accepted === null) {
                                this.agb = true;
                            }
                        });
                    }
                });
            }
        });
    }

    private async initializeAsync(): Promise<void> {
        try {
            await this.subscriptionService.checkSubscriptionStatus();
        } catch (error) {
            console.error('Initialization error:', error);
        }
    }
    ngAfterViewInit(): void {}

    confirmAgb() {
        console.log(this.checked);
        if (this.checked === false) {
            this.showMessage($localize`Sie müssen unsere AGB und Datenschutzerklärung akzeptieren!`, 'error', $localize`:@@error:Fehler!`);
            return;
        }

        this.userService.cofirmAGBStatus().subscribe({
            next: (d) => {
                console.log(d);
                this.agb = false;
            },
            error: (d) => {
                this.showMessage($localize`Bei der Bestätigung der AGB ist ein Fehler aufgetreten!`, 'error', $localize`:@@error:Fehler!`);
            },
        });
    }

    showMessage(msg: string, type = 'error', summary = 'Fehler'): void {
        this.message.add({
            key: 'msgs',
            severity: type,
            life: 8000,
            summary,
            detail: msg,
        });
    }
}